_getUserUsernameAvailabilityThunk